<template>
    <div v-if="isVisible" class="modal-overlay">
      <div class="modal-content">
        <h3>Set Referral Points</h3>
        <div class="form-group">
          <label for="points">Points:</label>
          <input type="number" id="points" v-model="points" class="form-control" />
        </div>
        <div class="form-group">
          <label for="remarks">Remarks:</label>
          <textarea id="remarks" v-model="remarks" class="form-control"></textarea>
        </div>
        <div class="modal-actions">
          <button @click="submit" class="btn btn-primary">Submit</button>
          <button @click="close" class="btn btn-secondary">Cancel</button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
import axios from 'axios';

  export default {
    props: ['isVisible'],
   
    data() {
      return {
        points: 0,
        remarks: '',
      };
    },
    mounted() {
      this.points = this.pointforallcustomer;
    },
    methods: {
      close() {
        this.$emit('close');
      },
      submit() {
        const paramjson = {
          points: this.points,
          remarks: this.remarks,
        };
        // this.$emit('submit', data);
        axios.post('/api/companymaster/json/save',  {paramjson})
          .then(response => {
            console.log('Points set successfully:', response.data);
            // this.$emit('submit', data);
          })
          .catch(error => {
            console.error('Error setting points:', error);
          });
        this.close();
      },
    },
  };
  </script>
  
  <style>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;

  }
  .modal-content {
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 400px;
  }
  .modal-actions {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }
  </style>